var map = {
	"./goerli-dev": 74731,
	"./goerli-dev.json": 74731,
	"./goerli-prod": 37766,
	"./goerli-prod.json": 37766,
	"./goerli-staging": 87978,
	"./goerli-staging.json": 87978,
	"./mainnet": 70519,
	"./mainnet-preview": 55078,
	"./mainnet-preview.json": 55078,
	"./mainnet.json": 70519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36327;